export const images = [
  {
    large: 'https://images.pexels.com/photos/414612/pexels-photo-414612.jpeg',
  },
  {
    preview: 'https://via.placeholder.com/150',
    large: 'https://via.placeholder.com/1500',
  },
  {
    large: 'https://via.placeholder.com/400x200',
  },
  {
    large: 'https://via.placeholder.com/200x400',
  },
] as const
